export default __webpack_public_path__ + "static/media/frango-mobile-2.24dbc3e7.png";